import { executeRequest, Request } from '@jfs/network'
import { RootStore } from '../../data/store'
import { getNetworkResponseError, isStatusOK } from '../../util/utill'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

const responseParser = (data: any) => {
  if (isStatusOK(data)) {
    return data?.data
  } else {
    throw getNetworkResponseError(data?.data)
  }
}

const customerData = (body: any, authorizationCode: string) => {
  return {
    //API Gateway Authorization code
    authorizationCode: authorizationCode,
    aadharToken: RootStore.customerDetails?.aadhaarToken,
    remittanceUserId: RootStore.customerDetails.remittanceUserId,
    user: {
      mobile: {
        mobileNumber: body?.mobile,
      },
      name: {
        firstName: body?.firstName,
        middleName: '',
        lastName: body?.lastName,
      },
      dob: body?.dob,
      occupationCode: 5, //hard coded
      address: [
        {
          state: body?.state,
          city: body?.city,
          pincode: body?.pinCode,
          country: 'IN', //hard coded
          type: 10, //hard coded
          houseNumber: body?.doorNumber + ', ' + body?.street, //Street address line 1
          district: body?.city,
        },
      ],
    },
  }
}

export const addNewCustomerDetailsApi = (tokens: any, body: any, authorizationCode: string) => {
  const config = sitConfig(tokens)
  config.headers['x-user-access-token'] = RootStore?.bcAppInfo?.userAccessToken
  config.headers['x-userid-token'] = RootStore?.bcAppInfo?.userIdentifier

  const request: Request<{}> = {
    apiPath: APIEndPoints.createRemittanceUser,
    method: 'POST',
    config,
    body: customerData(body, authorizationCode),
  }
  sendEventApi(tokens, request, {
    status: 'INIITATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}
